var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "mobile" },
      [
        _c("VueSkeletonLoader", {
          attrs: {
            type: _vm.defaults.type,
            width: "100%",
            height: "56px",
            color: _vm.defaults.color,
            animation: _vm.defaults.animation,
            "wave-color": _vm.defaults.waveColor,
          },
        }),
        _vm._v(" "),
        _c("VueSkeletonLoader", {
          attrs: {
            type: _vm.defaults.type,
            width: "100%",
            height: "56px",
            color: _vm.defaults.color,
            animation: _vm.defaults.animation,
            "wave-color": _vm.defaults.waveColor,
          },
        }),
        _vm._v(" "),
        _c("VueSkeletonLoader", {
          attrs: {
            type: _vm.defaults.type,
            width: "100%",
            height: "56px",
            color: _vm.defaults.color,
            animation: _vm.defaults.animation,
            "wave-color": _vm.defaults.waveColor,
          },
        }),
        _vm._v(" "),
        _c("VueSkeletonLoader", {
          attrs: {
            type: _vm.defaults.type,
            width: "100%",
            height: "48px",
            color: _vm.defaults.color,
            animation: _vm.defaults.animation,
            "wave-color": _vm.defaults.waveColor,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "desktop" },
      [
        _c("VueSkeletonLoader", {
          attrs: {
            type: _vm.defaults.type,
            width: "100%",
            height: "56px",
            color: _vm.defaults.color,
            animation: _vm.defaults.animation,
            "wave-color": _vm.defaults.waveColor,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }